var map = {
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts"
	],
	"./main/content/coming-soon/coming-soon.module": [
		"./src/app/main/content/coming-soon/coming-soon.module.ts",
		"main-content-coming-soon-coming-soon-module"
	],
	"./main/content/game/game.module": [
		"./src/app/main/content/game/game.module.ts"
	],
	"./main/content/inquiry/inquiry.module": [
		"./src/app/main/content/inquiry/inquiry.module.ts"
	],
	"./main/content/privacy-policy/privacy-policy.module": [
		"./src/app/main/content/privacy-policy/privacy-policy.module.ts",
		"main-content-privacy-policy-privacy-policy-module"
	],
	"./main/content/push-notifications/push-notifications.module": [
		"./src/app/main/content/push-notifications/push-notifications.module.ts"
	],
	"./main/content/sample/sample.module": [
		"./src/app/main/content/sample/sample.module.ts"
	],
	"./main/content/statistics/statistics.module": [
		"./src/app/main/content/statistics/statistics.module.ts",
		"main-content-statistics-statistics-module"
	],
	"./main/main.module": [
		"./src/app/main/main.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;